<template>
  <component-in-worker>
    <h2>Sección en construcción</h2>
  </component-in-worker>
</template>

<script>
// test
import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "DealsQuotesDdeliveredKpi",
  components: {
    ComponentInWorker
  }
};
</script>

<style></style>
